export default __webpack_public_path__ + "static/media/IBMCloud.4d47fcb5.svg";